import { render } from "./Crew.vue?vue&type=template&id=038c1554&scoped=true"
import script from "./Crew.vue?vue&type=script&lang=js"
export * from "./Crew.vue?vue&type=script&lang=js"

import "./Crew.vue?vue&type=style&index=0&id=038c1554&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038c1554"]])

export default __exports__